import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReportService } from './report.service';
import { IReportSum } from './report-sum';
import { IReportOrder } from './report-order';
import { IPeilutDdl } from './peilut-ddl';
import { ITatPeilutDdl } from './tat-peilut-ddl';

import { CustomerPeilutFilter } from '../../shared/pipes/custom-peilut-filter.pipe';
import { CustomerTatPeilutDdlFilter } from '../../shared/pipes/custom-tat-peilutddl-filter.pipe';
import { CustomDisabledDirective } from '../../shared/directives/custom-disabled.directive'
import { CustomerMsZehutFilter } from '../../shared/pipes/custom-ms-zehut-filter.pipe';
import { CustomerHamtanaFilter } from '../../shared/pipes/custom-hamtana-filter.pipe';

@Component({
    moduleId: module.id,
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css'],
    providers: [ReportService],
})




export class ReportComponent implements OnInit {
    constructor(private _reportService: ReportService, private router: Router) { }
    sumReports: IReportSum[];
    orderReport: IReportOrder[];
    peiluyotDdl: Array<IPeilutDdl>;
    tatPeiluyotDdl: Array<ITatPeilutDdl>;
    selectedPeilut: number = 0;
    selectedTatPeilut: number = 0;
    selectedReshimatHamtana: boolean = false;
    ms_zehut_filter: string;


    ngOnInit(): void {
        this._reportService.getReportSum()
            .subscribe(r => { this.sumReports = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getPeilutDdl()
            .subscribe(r => { this.peiluyotDdl = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getTatPeilutDdl()
            .subscribe(r => { this.tatPeiluyotDdl = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })

        this._reportService.getReportOrders()
            .subscribe(r => { this.orderReport = r }
            , error => {
                localStorage.removeItem("token");
                location.reload();
            })
    }

    onPeilutChange(newValue) {
        this.selectedPeilut = newValue;
        this.selectedTatPeilut = 0;
        this.ms_zehut_filter = null;
        this.selectedReshimatHamtana = false;
    }

    onTatPeilutChange(newValue) {
        this.selectedTatPeilut = newValue;
        this.ms_zehut_filter = null;
        this.selectedReshimatHamtana = false;

    }
}

